import ModelTree from './ModelTree.vue'

export default ModelTree



// WEBPACK FOOTER //
// ./src/lib/components/depend/index.js